module.exports = __webpack_public_path__ + "media/application/images/icons/idc-d7d8f8d551bdec339b21b8ec033ce540.svg";